export const isValidDate = function(date: any) {
  if (date === 'now') {
    return true;
  }
  const date_ = new Date(date);
  return date_.toString() !== 'Invalid Date' && !isNaN(date_.getTime());
};
